import { application } from "./application"

import AnalyticsController from "./analytics_controller"
import AutoReloadController from "./auto_reload_controller"
import BuzzerSoundController from "./buzzer_sound_controller"
import ClipboardController from "./clipboard_controller"
import JudgeOverlayController from "./judge_overlay_controller"
import PanelCanvasController from "./panel_canvas_controller"
import PanelTimerController from "./panel_timer_controller"
import ShareController from "./share_controller"

application.register("analytics", AnalyticsController)
application.register("auto-reload", AutoReloadController)
application.register("buzzer-sound", BuzzerSoundController)
application.register("clipboard", ClipboardController)
application.register("judge-overlay", JudgeOverlayController)
application.register("panel-canvas", PanelCanvasController)
application.register("panel-timer", PanelTimerController)
application.register("share", ShareController)
